import RefreshIcon from '@mui/icons-material/Refresh';
import { Box, Button, Dialog, DialogContent, Typography } from '@mui/material';

interface PortfoliosErrorModalProps {
  onRetry: () => void;
}

export const PortfoliosErrorModal = ({
  onRetry,
}: PortfoliosErrorModalProps) => {
  return (
    <Dialog
      open={true}
      fullScreen
    >
      <DialogContent>
        <Box
          sx={{
            height: '100%',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <Typography
            variant='h6'
            textAlign='center'
            sx={{ fontWeight: 400, lineHeight: 1 }}
          >
            Something went wrong.
          </Typography>
          <Typography
            variant='h6'
            textAlign='center'
            sx={{ mb: 2, fontWeight: 400 }}
          >
            Please try again.
          </Typography>
          <Button
            variant='contained'
            onClick={onRetry}
            size='large'
            startIcon={<RefreshIcon sx={{ fontSize: '1.2rem !important' }} />}
            sx={{
              borderRadius: 2,
              px: 3,
              fontWeight: 400,
            }}
          >
            RETRY
          </Button>
        </Box>
      </DialogContent>
    </Dialog>
  );
};
